module.exports = __webpack_public_path__ + "static/media/sky-red.936487f3.jpg";